import React, { useState } from "react";
import {
  DataGrid,
  gridClasses,
  gridPageCountSelector,
  gridPageSelector,
  useGridApiContext,
  useGridSelector,
} from "@mui/x-data-grid";
import Pagination from "@mui/material/Pagination";
import PaginationItem from "@mui/material/PaginationItem";
import { Link, useNavigate } from "react-router-dom";
import { confirmAlert } from "react-confirm-alert"; // Import
import "react-confirm-alert/src/react-confirm-alert.css";
import { ToastContainer, toast, Zoom, Slide } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useAuth } from "../../context/auth";
import axios from "axios";
import { useMutation, useQuery } from "react-query";
import { ThreeDots } from "react-loader-spinner";
import { useThemeContext } from "../../context/ThemeContext";
import AddRealEstateModal from "./components/AddRealEstateModal";
const RealEstate = () => {
  const [realEstates, setRealEstates] = useState([]);
  const [realEstateId, setRealEstateId] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [editId, setEditId] = useState(null);
  const navigate = useNavigate();
  const { token, user } = useAuth();
  const { currentMode, setCurrentMode } = useThemeContext();
  const headers = {
    "Content-Type": "application/json",
    Accept: "application/json",
    Authorization: `Bearer ${token}`,
  };
  const realEstatesData = useQuery(
    ["realEstatesDataApi", isModalOpen, realEstateId],
    async () =>
      await axios.get(`${process.env.REACT_APP_BACKEND_URL}owner`, {
        headers,
      }),
    {
      keepPreviousData: true,
      refetchOnWindowFocus: false,
      retry: false,
      enabled: !!token,
      onSuccess: (res) => {
        setRealEstates(
          res?.data?.map((data, index) => ({ ...data, index: index + 1 }))
        );
      },
    }
  );
  console.log(realEstates);
  const handleDelete = (id) => {
    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <div className="bg-[#edf2f6]  p-4 py-4 flex items-center flex-col space-y-2">
            <h1 className="text-dark-color font-bold">
              Are You Sure, You want to delete this RealEstate it is risky ?
            </h1>

            <div className="flex items-center justify-center space-x-5 w-full">
              <button
                onClick={onClose}
                className="bg-blue-bg rounded-sm text-center
                     px-5 p-2 font-medium text-sm text-white capitalize"
              >
                No
              </button>
              <button
                onClick={() => {
                  deleteRealEstateMutationHandler(id);
                  onClose();
                }}
                className="bg-red-500 rounded-sm text-center
              px-5 p-2 font-medium text-sm text-white capitalize"
              >
                Yes
              </button>
            </div>
          </div>
        );
      },
    });
  };

  const realEstateDeleteMutation = useMutation(
    async (id) =>
      await axios.delete(
        `${process.env.REACT_APP_BACKEND_URL}owner/find/${id}`,
        { headers }
      ),
    {
      retry: false,
    }
  );
  const deleteRealEstateMutationHandler = async (id) => {
    try {
      realEstateDeleteMutation.mutate(id, {
        onSuccess: (responseData) => {
          toast.info(
            "Agent deleted successfully",
            { theme: "colored" },
            {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: false,
              draggable: true,
              progress: undefined,
            }
          );
          setRealEstateId(null);
        },
        onError: (err) => {
          toast.error(
            err?.response?.data?.message,
            { theme: "colored" },
            {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: false,
              draggable: true,
              progress: undefined,
            }
          );
        },
      });
    } catch (err) {
      console.log(err);
    }
  };

  const columns = [
    { field: "index", headerName: "ID", width: 70, headerAlign: "left" },
    {
      field: "logo",
      headerName: "Logo",
      width: 100,
      renderCell: (params) => {
        console.log({ params: params });
        return (
          <img
            src={params?.row?.logo}
            alt=""
            className="h-10 max-w-8 object-cover w-full rounded-md"
          />
        );
      },
    },
    {
      field: "name",
      headerName: "Name",
      width: 160,
      sortable: false,
      filterable: false,
      headerClassName: "super-app-theme--header",
      headerAlign: "left",
    },

    {
      field: "phone",
      headerName: "phoneNo",
      width: 150,
      sortable: false,
      filterable: false,
      headerClassName: "super-app-theme--header",
      headerAlign: "left",
    },
    {
      field: "address",
      headerName: "address",
      width: 280,
      sortable: false,
      filterable: false,
      headerClassName: "super-app-theme--header",
      headerAlign: "left",
    },
    {
      field: "action",
      headerName: "action",
      width: 200,
      renderCell: (params) => {
        return (
          <div className="flex items-center space-x-3">
            <button
            disabled={realEstateDeleteMutation.isLoading}
              onClick={() => {
                handleDelete(params.row._id);
                setRealEstateId(params.row._id);
              }}
              className="bg-red-500 rounded-sm 
                    text-center px-3 p-1 font-medium text-sm text-white"
            >
              {realEstateId === params.row._id
                ? realEstateDeleteMutation.isLoading
                  ? "deleting..."
                  : "Delete"
                : "Delete"}
            </button>
            <button
             disabled={realEstateDeleteMutation.isLoading}
              onClick={() => {
                setEditId(params.row._id);
                setIsModalOpen(true);
              }}
              className="bg-blue-bg rounded-sm hover:opacity-80
              text-center px-5 p-1 font-medium text-sm text-white"
            >
              Edit
            </button>
          </div>
        );
      },
    },
  ];

  function CustomPagination() {
    const apiRef = useGridApiContext();
    const page = useGridSelector(apiRef, gridPageSelector);
    const pageCount = useGridSelector(apiRef, gridPageCountSelector);

    return (
      <Pagination
        shape="rounded"
        page={page + 1}
        count={pageCount}
        renderItem={(props2) => <PaginationItem {...props2} disableRipple />}
        onChange={(event, value) => apiRef.current.setPage(value - 1)}
      />
    );
  }
  return (
    <div className="p-3 md:p-5 ">
      <div className="bg-white dark:bg-secondary-dark-bg p-2 md:p-5 rounded-lg">
        <div className="flex items-center justify-between py-4 ">
          <h1 className="text-dark-color dark:text-white font-bold text-2xl">
            RealEstates
          </h1>
          <button
            onClick={() => setIsModalOpen(true)}
            className="p-2 px-5 bg-[#216fed] font-medium text-white rounded-md hover:opacity-80"
          >
            +Add Real Estate
          </button>
        </div>
        {realEstatesData.isFetched ? (
          realEstatesData?.data?.data?.length > 0 ? (
            realEstates?.length > 0 ? (
              <div style={{ height: 520 }} className="">
                <DataGrid
                  rows={realEstates}
                  columns={columns}
                  pageSize={7}
                  rowsPerPageOptions={[5]}
                  disableSelectionOnClick
                  getRowId={(row) => row._id}
                  sx={{
                    "&::-webkit-scrollbar": {
                      display: "none",
                    },
                    "& .super-app-theme--header": {
                      borderColor:
                        currentMode === "Dark" ? "#475569" : "#64748b",
                      border: "none",
                    },
                    color: currentMode === "Dark" ? "#EEF1F6" : "#000",
                    border: 2,
                    borderColor: currentMode === "Dark" ? "#475569" : "#64748b",
                    [`& .${gridClasses.cell}`]: {
                      borderColor: (theme) =>
                        currentMode === "Dark" ? "#475569" : "#64748b",
                    },
                    [`& .${gridClasses.row}`]: {
                      borderColor: (theme) =>
                        currentMode === "Dark" ? "#475569" : "#64748b",
                      textAlign: "center",
                    },
                    "& .MuiDataGrid-cellCenter": {
                      justifyContent: "center",
                    },
                    "&.MuiDataGrid-root .MuiDataGrid-cell": {
                      outline: "none",
                      textAlign: "left",
                      border: "none",
                    },
                    "& .MuiPaginationItem-root": {
                      color: currentMode === "Dark" ? "#aeaeae" : "#64748b",
                      // backgroundColor:'red'
                      border: "none",
                    },
                  }}
                  components={{
                    Pagination: CustomPagination,
                  }}
                />
              </div>
            ) : (
              <div className="flex items-center justify-center">
                <ThreeDots
                  height="80"
                  width="80"
                  radius="9"
                  color="#216fed"
                  ariaLabel="three-dots-loading"
                  wrapperStyle={{}}
                  wrapperClassName=""
                  visible={true}
                />
              </div>
            )
          ) : (
            <div className="flex items-center justify-center w-full text-center">
              <h1 className="capitalize text-dark-gray text-2xl font-bold text-center">
                You have no properties
              </h1>
            </div>
          )
        ) : (
          <div className="flex items-center justify-center">
            <ThreeDots
              height="80"
              width="80"
              radius="9"
              color="#216fed"
              ariaLabel="three-dots-loading"
              wrapperStyle={{}}
              wrapperClassName=""
              visible={true}
            />
          </div>
        )}
        <AddRealEstateModal
          setIsModalOpen={setIsModalOpen}
          isModalOpen={isModalOpen}
          editId={editId}
          setEditId={setEditId}
        />
        <ToastContainer
          position="top-right"
          autoClose={3000}
          hideProgressBar
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover={false}
          transition={Slide}
        />
      </div>
    </div>
  );
};

export default RealEstate;
